import { render } from "./LPRankingUser.vue?vue&type=template&id=e2ae1b56&ts=true&lang=pug"
import script from "./LPRankingUser.vue?vue&type=script&lang=ts"
export * from "./LPRankingUser.vue?vue&type=script&lang=ts"

import "./LPRankingUser.vue?vue&type=style&index=0&id=e2ae1b56&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__